import './modal-close-button.css';

interface ModalCloseButtonProps {
  className?: string;
  disabled?: boolean;
  label: string;
  onClick: () => void;
}

export function ModalCloseButton({
  className = '',
  disabled = false,
  label,
  onClick,
}: ModalCloseButtonProps) {
  return (
    <button
      aria-label={label}
      className={`modal-close-button${className ? ` ${className}` : ''}`}
      disabled={disabled}
      type="button"
      onClick={onClick}
    >
      <span aria-hidden="true">&times;</span>
    </button>
  );
}
